import { render, staticRenderFns } from "./ContratoDrag.vue?vue&type=template&id=573fcbc3"
import script from "./ContratoDrag.vue?vue&type=script&lang=js"
export * from "./ContratoDrag.vue?vue&type=script&lang=js"
import style0 from "./ContratoDrag.vue?vue&type=style&index=0&id=573fcbc3&prod&lang=stylus"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports